export default {
  settingZones: {
    header: {
      province: 'Province',
      city: 'City',
      district: 'District',
    },

    table: {
      province: 'Province',
      city: 'City',
      district: 'District',
      logistics: 'Specified Logistics',
      logisticsBusiness: 'Specified Logistics Service',
      updater: 'Updated By',
      lastUpdated: 'Last Updated Time',
    },

    dialog: {
      editTitle: 'Edit province, city, and district configuration',
      addTitle: 'Create province, city, and district configuration',
      province: 'Province',
      city: 'City',
      district: 'District',
      logistics: 'Specified Logistics',
      selectLogistics: 'Please select specified logistics',
      business: 'Specified Business',
      selectBusiness: 'Please select specified business',
      selectLogisticsValid: 'Please select the associated logistics provider first',
      selectProvince: 'Please Select Province',
      urbanArea: 'Please Select City',
      area: 'Please Select District',
    }
  }
};
